import Icon from '../components/Icon.vue'

Icon.register({
  brain: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M208 0C178.1 0 153.3 20.6 146.2 48.2 145.4 48.2 144.8 48 144 48 108.7 48 80 76.6 80 112 80 116.8 80.6 121.5 81.7 126 52.5 138 32 166.6 32 200 32 212.6 35.2 224.3 40.3 234.9 16.3 248.7 0 274.3 0 304 0 337.3 20.4 365.9 49.4 377.9 48.5 382.5 48 387.2 48 392 48 431.8 80.2 464 120 464 124.1 464 128.1 463.4 132 462.8 141.6 491.3 168.3 512 200 512 239.8 512 272 479.8 272 440V205.4C261.1 214.4 248 220.9 233.6 223.8 228.7 224.9 224 221 224 215.9V199.8C224 196.2 226.3 193 229.8 192.1 254 185.9 272 164.2 272 138.1V64C272 28.6 243.3 0 208 0zM576 304C576 274.3 559.7 248.7 535.7 234.9 540.8 224.3 544 212.6 544 200 544 166.6 523.5 138 494.3 126 495.4 121.5 496 116.8 496 112 496 76.6 467.3 48 432 48 431.3 48 430.6 48.2 429.8 48.2 422.7 20.6 397.9 0 368 0 332.7 0 304 28.6 304 64V138.1C304 164.2 322 185.9 346.2 192.1 349.7 193 352 196.2 352 199.8V215.9C352 221 347.3 224.9 342.4 223.8 328 220.9 314.9 214.4 304 205.4V440C304 479.8 336.2 512 376 512 407.8 512 434.4 491.3 444 462.8 447.9 463.5 451.9 464 456 464 495.8 464 528 431.8 528 392 528 387.2 527.5 382.5 526.6 377.9 555.6 365.9 576 337.3 576 304z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brain.js
// module id = m0rq
// module chunks = 144